import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .UserPammAccounts {
    font-size: 16px;

    &__title {
      width: 100%;
      display: flex;
      flex-direction: column;

      .title {
        white-space: normal;
        display: block;
        font-size: 15px;
        font-weight: 500;
        color: #000;
        margin-bottom: 3px;
      }

      .masterAccount {
        white-space: normal;
      }
    }

    :global(.ReactTable) {
      :global(.rt-tbody) {
        overflow: hidden;
      }

      :global(.rt-tbody),
      :global(.rt-thead),
      :global(.rt-tr-group) {
        min-width: 1050px !important;

        @include respond-to(lg) {
          min-width: 888px !important;
        }

        @include respond-to(md) {
          min-width: 763px !important;
        }
      }
    }

    &--noAccounts {
      box-shadow: 0 1px 6px 1px rgba(0, 0, 0, 0.06);
      padding: rem(25px 30px 25px);
      @include respond-to(sm) {
        padding: rem(20px 15px 15px);
      }
      h2 {
        margin-bottom: rem(25px);
      }
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css`
    :global(.UserPammAccounts__manager-link) {
      color: ${colors.primary.hex};
    }

    .UserPammAccounts--noAccounts {
      background-color: ${colors.white.hex};
    }
  `;
};

export { staticStyles, getDynamicStyles };
